import { event } from '@abyss/web/tools/event';

export const adobeStandardSearchEvent = (input) => {
  const { customAttributesBlock } = input;

  event('STANDARD_SEARCH_EVENT', {
    search: {
      term: input?.term?.toLowerCase() ?? '',
      type: input.isGuest ? input.type ?? 'site' : 'provider',
      filters: input?.filters ?? '',
      results: String(input?.numberOfResults) ?? '',
      method: input?.method?.toLowerCase() ?? '',
    },
    link: {
      name: input?.linkName?.toLowerCase().replaceAll('-', ' '),
    },
    component: {
      name: '',
    },
    ...(customAttributesBlock && { customAttributes: customAttributesBlock }),
  });
};
